var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insidePageLeft"},[_c('ul',_vm._l((_vm.leftli),function(item,index){return _c('li',{key:index,class:{'active':_vm.ind === index},on:{"click":function($event){return _vm.changeBgc(index)}}},[_c('router-link',{attrs:{"to":"/major"}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b27fb4bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/InsidePageLeft.vue
// module id = null
// module chunks = 